<template>
  <div>
    <div class="head-box">
      <h4>{{ channelName }}模板</h4>
      <div class="c-flex">
        <el-input
          placeholder="请输入描述"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新建模板</el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table ref="table" height="calc(100% - 50px)" :data="fpi.data" highlight-current-row>
          <el-table-column fixed="right" width="220" label="操作">
            <template slot-scope="scope">
              <el-button @click.native.prevent="doEdit(scope.row)" size="mini">
                编辑
              </el-button>
              <template v-if="scope.row.state == 0">
                <el-button
                  @click.native.prevent="doEnable(scope.row._id)"
                  type="danger"
                  size="mini"
                >
                  已禁用
                </el-button>
              </template>
              <template v-else>
                <el-button
                  @click.native.prevent="doDisable(scope.row._id)"
                  type="success"
                  size="mini"
                >
                  已启用
                </el-button>
              </template>
              <el-button @click.native.prevent="doRemove(scope.row._id)" size="mini">
                删除
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            label="环节"
            width="100"
            fixed
            :formatter="formatNotification"
          ></el-table-column>
          <el-table-column
            prop="roleId"
            label="接收人"
            width="100"
            :formatter="formatRole"
          ></el-table-column>
          <el-table-column
            prop="description"
            label="描述"
            width="300"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="模板内容" width="150">
            <template slot-scope="scope">
              <el-popover placement="top" width="200" trigger="hover">
                <div v-html="scope.row.content"></div>
                <el-button type="text" slot="reference">预览</el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="param" label="参数"></el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog :title="channelName + '模板'" :visible.sync="openDetail">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="90px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item label="环节" prop="type">
          <el-select v-model="formData.type">
            <el-option
              v-for="item in options.notification"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="接收人" prop="roleId">
          <el-select v-model="formData.roleId">
            <el-option
              v-for="item in options.roles"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="formData.title"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="formData.description"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" v-model="formData.content"></el-input>
        </el-form-item>
        <el-form-item label="参数">
          <el-input v-model="formData.param"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'notification',
  data() {
    return {
      channel: '',
      channelName: '',
      tenantId: '',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {},
      rules: this.$util.rules,
      options: {
        codecfg_notification: { codeId: 'NOTIFICATION' }
      }
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      window.$this = this;
      this.channel = this.osg.param('channel');
      let channelName = '';
      switch (this.channel) {
        case '1':
          channelName = '短信';
          break;
        case '2':
          channelName = '站内信';
          break;
        case '3':
          channelName = '公众号通知';
          break;
        case '4':
          channelName = '小程序通知';
          break;
        default:
      }
      this.channelName = channelName;
      this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
      this.fpi = {};
      this.searchValue = '';
      this.doInit();
      this.getRoles();
      this.osg.codeoption(() => {
        this.getData();
      });
    },
    formatState(row, column, cellValue, index) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    formatNotification(row, column, cellValue, index) {
      return this.osg.codelabel('notification', cellValue);
    },
    formatRole(row, column, cellValue, index) {
      return this.osg.codelabelForArray('roles', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {};
      if (this.$refs.formData) this.$refs.formData.resetFields();
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:description|string#or': this.searchValue,
        channel: this.channel,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('notification/template/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      this.formData.channel = this.formData.channel || this.channel;
      this.formData.tenantId = this.formData.tenantId || this.tenantId;
      this.formData.roleName = this.osg.codelabel('roles', this.formData.roleId);
      if (this.osg.validate()) {
        this.osg.ajax('notification/template/upsert.do', this.formData, res => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax(`notification/template/enable/${id}.do`, null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax(`notification/template/disable/${id}.do`, null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除此模板？', () => {
        this.osg.ajax(`notification/template/remove/${id}.do`, null, res => {
          this.getData();
          this.osg.toast('操作成功！');
        });
      });
    },
    getRoles() {
      this.osg.ajax('role/query.do', { page: 1, rows: 100 }, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.roles = res.data;
      });
    }
  }
  // watch: {
  //   $route(to, from) {
  //     this.refresh();
  //   }
  // }
};
</script>
